import api from 'api/api'

export const GET_PAYMENT_TYPES = '[PAYMENT TYPES] GET PAYMENT TYPES'

export function getPaymentTypesAction() {
  const request = api.get('/payment-types/all')
  return (dispatch) => {
    dispatch({ type: GET_PAYMENT_TYPES, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_PAYMENT_TYPES, payload: { data: response.data.data } })
    }).catch((error) => {
      console.log(GET_PAYMENT_TYPES, error)
    }).finally(() => {
      dispatch({ type: GET_PAYMENT_TYPES, payload: { loading: false } })
    })
  }
}